import React from "react"
import Login from "./components/auth/login"
import Logout from "./components/auth/logout"
import Home from "./components/Home/index"
import NotFound from "./components/not-found"
import { Switch, Route } from "react-router-dom"

import { ProtectedRoute } from "./middlewares/routes-auth.middleware"
const App = () => (
  <Switch>
    <ProtectedRoute path="/offer" component={Home} />
    <ProtectedRoute path="/request" component={Home} />
    <ProtectedRoute path="/home" component={Home} />
    <Route path="/logout" exact component={Logout} />
    <Route path="/login" exact component={Login} />
    <Route path="/" exact component={Login} />
    <Route path="*" component={NotFound} />
  </Switch>
)
//<ProtectedRoute path = "/request" component = { Home } />

export default App
